module.exports = __webpack_public_path__ + "static/media/CityLine.9fa35e6f.jpg";